import React, { FormEvent, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

import { Button, Modal, TextareaAutosize } from '@material-ui/core';
import { colors } from '../../const/Styles';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../contexts/StoreContext';
import { CustomerDisplay } from '../../../store/LessonStore';

const StyledModal = styled(Modal)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

const StyledTextField = styled(TextareaAutosize)`
    background-color: ${colors.white};
    color: ${colors.black};
    border: solid 2px ${colors.lightGray};
    font-size: 1.1rem;
    padding: 1rem;
`;

const Container = styled.div`
    display: grid;
    grid-template-rows: max-content 1fr max-content;
    gap: 50px;
    width: calc(100% - 100px);
    box-sizing: border-box;
    padding: 40px 20px;
    border: solid 4px ${colors.white};
    border-radius: 4px;
    background-color: ${colors.black};
    overflow-y: auto;
`;

const Header = styled.h1`
    margin: 0;
    font-weight: bold;
    color: ${colors.footerIconSelected};
    font-size: 2.5rem;
`;

const Footer = styled(Button)`
    background-color: ${colors.footerIconSelected};
    color: ${colors.black};
    margin: 0 100px;
    font-size: 1.2rem;
    font-weight: bold;
`;

type Props = {
    isOpended: boolean;
    onClose: () => void;
    customer: CustomerDisplay;
};

const LessonCommentModal: React.FC<Props> = ({
    isOpended,
    onClose,
    customer,
}) => {
    const { lessonStore } = useStore();
    const [text, setText] = useState('');
    useEffect(() => {
        setText(lessonStore.getLessonComment(String(customer.id)));
    }, [customer.id, isOpended, lessonStore]);
    lessonStore.getLessonComment(String(customer.id));

    const handleInput = useCallback((evt: FormEvent<HTMLTextAreaElement>) => {
        setText(evt.currentTarget.value);
    }, []);

    const handleSubmit = () => {
        lessonStore.setLessonComment(String(customer.id), text.trim());
        onClose();
    };

    return (
        <StyledModal open={isOpended} onClose={onClose}>
            <Container>
                <Header>本日のコメント</Header>
                <StyledTextField rows={20} value={text} onInput={handleInput} />
                <Footer onClick={handleSubmit}>登録</Footer>
            </Container>
        </StyledModal>
    );
};

export default observer(LessonCommentModal);
